import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { find, first } from 'lodash';
import {
  FormGroup, ControlLabel, Button,
  OverlayTrigger, Tooltip, Dropdown, MenuItem,
} from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import tinycolor from 'tinycolor2';

import { getColorFromKey } from '../../util/helpers';
import styles from './styles.css';

/*
const color1 = '#673AB7';
const white = '#ffffff';

export const COLORS = reduce(tinycolor(color1).tetrad(), (items, c) => {
  if (tinycolor.isReadable(c, white, {})) {
    items.push(c.toHexString());
  } else {
    items.push(c.complement().toHexString());
  }
  return items;
}, []);
*/
// export const COLORS = ['#03A9F4', '#009688', '#FF9800', '#E91E63', '#673AB7'];

export const COLORS = ['#264653', '#03A9F4', '#FF9800', '#2A9D8F', '#673AB7'];

export default function MasterFieldHoc(ComposedComponent) {
  class MasterField extends Component {
    constructor(props) {
      super(props);
      this.state = {};
      this.setType = this.setType.bind(this);
      this.deleteCriteria = this.deleteCriteria.bind(this);
    }

    setType(type) {
      const { path } = this.props;
      this.props.onUpdate(path, { type });
    }

    deleteCriteria() {
      const { path } = this.props;
      this.props.onDelete(path);
    }

    renderTypeDropdown() {
      const { searchCriteria, disabledInclude, disabled, readOnly, typeSetEnabled } = this.props;
      const hasError = searchCriteria.error !== undefined && searchCriteria.error !== null;

      const items = [
        { value: 'include', label: 'includes', color: getColorFromKey('won') },
        { value: 'exclude', label: 'excludes', color: getColorFromKey('lost') },
      ];

      if(typeSetEnabled) {
        items.push({ value: 'set', label: 'has value', color: getColorFromKey('noDecision') })
      };

      const activeItem = find(items, { value: searchCriteria.type }) || first(items);

      const toggleInner = readOnly ?
        (<span className="label label-default text-uppercase" style={{ color: activeItem.color, border: `1px solid ${activeItem.color}`, background: '#fff' }}>{activeItem.label}</span>) :
        (<span>{activeItem.label}</span>);

      let bsStyle = 'link';
      if (activeItem.value === 'include') {
        bsStyle = 'success';
      } else if (activeItem.value === 'exclude') {
        bsStyle = 'danger';
      } else if (activeItem.value === 'set') {
        bsStyle = 'warning';
      }

      return (
        <div>
          {!readOnly &&
            <Dropdown
              disabled={(disabled || disabledInclude || hasError)}
              id="criateria-type"
            >
              <Dropdown.Toggle block bsSize="xs" disabled={(disabled || disabledInclude)} bsStyle={bsStyle}>
                {toggleInner}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {items.map((item) => {
                  return (
                    <MenuItem
                      active={item.value === searchCriteria.type}
                      key={item.value}
                      onSelect={() => { this.setType(item.value); }}
                    >
                      <span>{item.label}</span>
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          }
          {readOnly && toggleInner}
        </div>
      );
    }

    render() {
      const {
        searchCriteria, disabled, showDelete, showInclude,
        color, readOnly, renderDescription, fullBorders,
      } = this.props;
      const removeBtnStyle = color ? { color: '#fff', backgroundColor: color } : {};
      const borderStyle = { borderColor: color, backgroundColor: tinycolor.mix(color, '#ffffff', 95).toHexString() };
      const { type } = searchCriteria;
      const col1Cls = readOnly ? 'col-sm-4 col-md-3' : 'col-sm-4 col-md-3';
      const col2Cls = readOnly ? 'col-sm-6 col-md-7' : 'col-sm-8 col-md-9';
      const col3Cls = 'col-sm-2 col-md-2';
      let description = null;
      if (renderDescription && searchCriteria.filter && searchCriteria.filter.description && searchCriteria.filter.description.length > 0) {
        const tip = (
          <Tooltip id={`${searchCriteria.filter._id}-tip`}>
            <div>{searchCriteria.filter.description}</div>
          </Tooltip>
        );
        description = (
          <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
            <Fa name="info-circle" className="text-active" />
          </OverlayTrigger>
        )
      }

      let compact = !readOnly && searchCriteria.filter && (type === 'include' || type === 'exclude') && (searchCriteria.filter.type === 'picklist' || searchCriteria.filter.type === 'multipicklist');
      if (searchCriteria.filter && searchCriteria.filter.is_boolean) {
        compact = true;
      }

      const hasError = searchCriteria.error !== undefined && searchCriteria.error !== null;

      const props = { ...this.props };
      if (hasError) {
        props.readOnly = true;
        props.disabled = true;
      }
      return (
        <div style={borderStyle} className={`${styles.field} ${compact ? styles.fieldAutoComplete : ''} ${fullBorders ? styles.fieldFullBorders : ''}`}>
          <FormGroup>
            <div className="row">
              <div className={`${col1Cls} ${styles.fieldLabel}`}>
                <div className="row">
                  <div className={showInclude ? "col-sm-6": "col-sm-12"}>
                    <ControlLabel>
                      <span className={hasError ? 'text-danger' : ''}>{searchCriteria.filter.label}</span> {description}
                    </ControlLabel>
                  </div>
                  {showInclude &&
                    <div className="col-sm-6">
                      {this.renderTypeDropdown()}
                    </div>
                  }
                </div>
              </div>
              <div className={`${col2Cls} ${styles.fieldType}`}>
                <ComposedComponent {...props} />
                {hasError &&
                  <div className="alert alert-danger">{searchCriteria.error}</div>
                }
              </div>
              {readOnly && searchCriteria.results != null &&
                <div className={col3Cls}>
                  <div className="text-right">
                    <span className={`label ${(searchCriteria.results === true ? 'label-success' : 'label-danger')}`}>{searchCriteria.results === true ? 'Passed' : 'Failed'}</span>
                  </div>
                </div>
              }
            </div>

            {showDelete && !readOnly &&
              <div className={styles.removeBtn}>
                <Button
                  disabled={disabled}
                  style={removeBtnStyle}
                  onClick={this.deleteCriteria}
                >
                  <Fa name="times-circle" />
                </Button>
              </div>
            }
          </FormGroup>
        </div>
      );
    }
  }

  MasterField.propTypes = {
    dispatch: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    disabledInclude: PropTypes.bool,
    onModalShow: PropTypes.func,
    onModalHide: PropTypes.func,
    level: PropTypes.number,
    path: PropTypes.arrayOf(PropTypes.string).isRequired,
    hasSiblingGroup: PropTypes.bool,
    showDelete: PropTypes.bool,
    showInclude: PropTypes.bool,
    searchCriteria: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      results: PropTypes.bool, // query explanation
      type: PropTypes.string,
      error: PropTypes.string,
      filter: PropTypes.shape({
        type: PropTypes.string,
        _id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        description: PropTypes.string,
        is_boolean: PropTypes.bool,
      }),
    }),
    searchType: PropTypes.string.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    color: PropTypes.string,
    readOnly: PropTypes.bool,
    renderDescription: PropTypes.bool,
    typeSetEnabled: PropTypes.bool,
    fullBorders: PropTypes.bool,
  };
  MasterField.contextTypes = {
    router: PropTypes.object.isRequired,
  };
  MasterField.defaultProps = {
    level: 0,
    hasSiblingGroup: false,
    showDelete: true,
    showInclude: true,
    disabled: false,
    disabledInclude: false,
    searchCriteria: null,
    onModalShow: () => {},
    onModalHide: () => {},
    onDelete: () => {},
    color: COLORS[1],
    readOnly: false,
    renderDescription: false,
    typeSetEnabled: true,
    fullBorders: false,
  };

  function mapStateToProps() {
    return {};
  }

  return connect(mapStateToProps)(MasterField);
}
